import { render } from "./bar-charts.vue?vue&type=template&id=0999f966&scoped=true"
import script from "./bar-charts.vue?vue&type=script&lang=js"
export * from "./bar-charts.vue?vue&type=script&lang=js"

import "./bar-charts.vue?vue&type=style&index=0&id=0999f966&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0999f966"]])

export default __exports__